export const createStringPropertyTypeGuard = <T extends string>(
  propertyName: T,
) => {
  return (value: unknown): value is { [K in T]: string } => {
    return (
      value !== null &&
      typeof value === 'object' &&
      propertyName in value &&
      typeof (value as Record<T, unknown>)[propertyName] === 'string'
    );
  };
};

export const createArrayPropertyTypeGuard = <T extends string>(
  propertyName: T,
) => {
  return (value: unknown): value is { [K in T]: unknown[] } => {
    return (
      value !== null &&
      typeof value === 'object' &&
      propertyName in value &&
      Array.isArray((value as Record<T, unknown>)[propertyName])
    );
  };
};

export const isObjectWithProperty = (
  value: unknown,
  propertyName: string,
): value is Record<string, unknown> => {
  return value !== null && typeof value === 'object' && propertyName in value;
};

export interface ValidationTypeGuards {
  createStringPropertyTypeGuard: typeof createStringPropertyTypeGuard;
  createArrayPropertyTypeGuard: typeof createArrayPropertyTypeGuard;
  isObjectWithProperty: typeof isObjectWithProperty;
}

export const getValidationTypeGuards = (): ValidationTypeGuards => ({
  createStringPropertyTypeGuard,
  createArrayPropertyTypeGuard,
  isObjectWithProperty,
});
